import PolygonBase from './PolygonBase';
import shapeSquareSVG from '../assets/icons/shapeSquare.svg';
import { svgToIcon } from '../utils/svg';
import { roundRectEdgePathString } from './utils';

class ShapeRect extends PolygonBase {
  static renderIcon() {
    return svgToIcon(shapeSquareSVG);
  }

  static pathString() {
    return `
      M -0.5 -0.5
      L 0.5 -0.5
      L 0.5 0.5
      L -0.5 0.5
      Z
    `;
  }

  static edgePathString() {
    return roundRectEdgePathString(0.01);
  }
}

export default ShapeRect;
